import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { FundDataCriteria } from '../models/fund-data-criteria';
import { SearchCriteria } from '../models/search-criteria';

@Injectable()
export class PensionOutlookService {
  private typeToUrl: string;
  constructor(
    private _http: HttpClient
  ) { 
  this.typeToUrl= 'erpt-service/api/v1/';

  }
  
  public setHttpHeaders(): HttpHeaders {
      let headers = new HttpHeaders();
      headers = headers.set('Content-Type', 'application/json; charset=utf-8');
      headers = headers.set('Cache-Control', 'no-store');
      headers = headers.set('Cache-Control', 'no-cache');
      return headers;
  }

  

  public getEmployers(): Observable<any> {
    return this._http.get(environment.PENSION_OUTLOOK_URL + this.typeToUrl + 'employers', { headers: this.setHttpHeaders() });
  }

  public getValuationYear(): Observable<any> {
    return this._http.get(environment.PENSION_OUTLOOK_URL + this.typeToUrl + 'open-valuation-year', { headers: this.setHttpHeaders() });
  }

  public getModelingData(fundDataCriteria: FundDataCriteria): Observable<any> {
    const params = new HttpParams({
      fromObject: {
       valuationYear: (fundDataCriteria.valuationYearId != null) ? fundDataCriteria.valuationYearId.toString() : '',
       employerCode: (fundDataCriteria.employerCode != null) ? fundDataCriteria.employerCode.toString() : ''
       
     }
   }); 

  return this._http.get(environment.PENSION_OUTLOOK_URL + this.typeToUrl + 'reference-data', { params: params, headers: this.setHttpHeaders() });
  }

  public getProjection(searchCriteria: SearchCriteria): Observable<any> {
    return this._http.post(environment.PENSION_OUTLOOK_URL + this.typeToUrl + 'projections', searchCriteria, { headers: this.setHttpHeaders() });
  }
}
